import { getSurveyFactoryAddress } from '@/config/get-survey-factory-address'
import { NetworkId } from '@/types/network'
import { useChainId } from 'wagmi'

/**
 * Fetches the address of the SurveyFactory contract according to the current chain
 * @returns The address of the SurveyFactory contract
 */
export function useSurveyFactoryContractAddress() {
	const chainId = useChainId()

	return getSurveyFactoryAddress(chainId as NetworkId)
}
